// import Login from './pages/login';
// import './App.css';
// import './css/bootstrap.min.css'
// import './css/style.css'
//import './css/fontawesome-all.min.css'
// import './css/animate.css'
import "./assets/css/style-starter.css";
import "./assets/css/popup.css";
import "./assets/css/typography.css";
import "./assets/css/ui-styles.css";

import Routes from "./routes";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import { ConfigProvider, Empty } from "antd";
import NoTableData from "./components/NoTableData";

const App = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === "production") {
      ReactGA.initialize("G-9N2CD6FM7V");
    }
  }, []);

  return (
    <ConfigProvider
      renderEmpty={(componentName) => {
        if (componentName === "Table") {
          return <NoTableData />;
        }
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
      }}
      theme={{
        token: {
          fontFamily: "Inter, system-ui, sans-serif",
          colorText: "#1e293b",
          colorPrimary: "#5d44ff",
          colorBorder: "#cbd5e1",
          colorTextPlaceholder: "#475569",
          borderRadius: 8,
        },
        components: {
          Input: {
            colorBorder: "#cbd5e1",
            colorTextPlaceholder: "#475569",
            colorText: "#1e293b",
          },
          Select: {
            colorBorder: "#cbd5e1",
            colorTextPlaceholder: "#475569",
            colorText: "#1e293b",
          },
          DatePicker: {
            colorBorder: "#cbd5e1",
            colorTextPlaceholder: "#475569",
            colorText: "#1e293b",
          },
        },
      }}
    >
      <Routes />
    </ConfigProvider>
  );
};

export default App;